import * as StatsTask from "../../../dzial9_prawdopodobienstwo/temat4_zadania_uzupelniajace_maturalne/podtemat3_otwarte_types/MaturaBarChartStatsOpenTask";

export function generateTask(options = {}) {
  const task = StatsTask.generateTask(options);

  return {
    ...task,
    type: "MaturaBarChartPercentageComparisonOpenTask",
    data: {
      ...task.data,
      coursePart: "percent",
      maxPoints: 1,
    },
  };
}

export const renderTask = StatsTask.renderTask;
export const renderInput = StatsTask.renderInput;
export const checkAnswer = StatsTask.checkAnswer;
export const renderAnswer = StatsTask.renderAnswer;
export const renderUserAnswer = StatsTask.renderUserAnswer;
export const renderExplanation = StatsTask.renderExplanation;
